import { getComicsBySlug } from "@/api/comics"
import { useQuery } from "@tanstack/react-query"

const useGetComicsDetail = (slug?: string | undefined) => {
  const { data: { data: comicsDetail } = {}, ...rest } = useQuery(
    ["comicsDetail", slug],
    () => getComicsBySlug(String(slug)),
    {
      retry: 1,
      enabled: !!slug,
    },
  )

  return {
    comicsDetail,
    ...rest,
  }
}

export default useGetComicsDetail
